import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Modal } from "react-bootstrap";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { adsList, approveAds, rejectAds, deleteAds } from "../../common/api";
import { ShowToast } from "../../common/function";
import { format } from "date-fns";
import { Sentry, Spinner } from "react-activity";
export default function AdsPage() {
  const [searchText, setSearchText] = useState("");
  const [adsData, setAdsData] = useState([]);
  const [show, setShow] = useState(false);
  const [adsId, setAdsId] = useState("");
  const [showapprove, setShowapprove] = useState(false);
  const [showreject, setShowreject] = useState(false);
  const [loadingapprove, setLoadingapprove] = useState(false);
  const [loadingreject, setLoadingreject] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleClose = () => setShow(false);
  const handleapproveClose = () => setShowapprove(false);
  const handlerejectClose = () => setShowreject(false);
  const handleShow = (adsId) => {
    setAdsId(adsId);
    setShow(true);
  };

  const handleapproveShow = (adsId) => {
    setAdsId(adsId);
    setShowapprove(true);
  };
  const handlerejectShow = (adsId) => {
    setAdsId(adsId);
    setShowreject(true);
  };
  const getStatusStyle = (status) => {
    switch (status) {
      case "approved":
        return {
          backgroundColor: "rgba(40, 199, 111, 0.12)",
          color: "#28c76f",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
      case "pending":
        return {
          backgroundColor: "rgba(146, 0, 0, 0.12)",
          color: "#920000",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
      case "rejected":
        return {
          backgroundColor: "rgba(255, 0, 0, 0.12)",
          color: "#ff0000",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
      default:
        return {};
    }
  };
  const formatDate = (dateString) => {
    return format(new Date(dateString), "dd-MM-yyyy");
  };

  const handleDelete = async (adsId) => {
    setDeleteLoading(true);
    const token = localStorage.getItem("token");
    const response = await deleteAds(token, { adsId });
    if (response.success) {
      ShowToast(1, response.message);
      handleClose();
      getAdsList();
      setDeleteLoading(false);
    }
  };

  const getAdsList = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const response = await adsList(token, {});
    if (response.success) {
      setLoading(false);
      setAdsData(response.body);
    } else {
      ShowToast(0, response.message);
    }
  };
  useEffect(() => {
    getAdsList();
  }, []);

  console.log("adsData", adsData);

  const handleApprove = async (adsId) => {
    setLoadingapprove(true);
    const token = localStorage.getItem("token");
    const response = await approveAds(token, { adsId });
    if (response.success) {
      setLoadingapprove(false);
      ShowToast(1, response.message);
      handleapproveClose();
      getAdsList();
    }
  };

  const handleReject = async (adsId) => {
    setLoadingreject(true);
    const token = localStorage.getItem("token");
    const response = await rejectAds(token, { adsId });
    if (response.success) {
      setLoadingreject(false);
      ShowToast(1, response.message);
      handlerejectClose();
      getAdsList();
    }
  };
  const getStatusStyle2 = (status) => {
    console.log('status',status);
    
    switch (status) {
      case "0":
        return {
          backgroundColor: "rgba(40, 199, 111, 0.12)",
          color: "#28c76f",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };

      case undefined:
        return {
          backgroundColor: "rgba(255, 0, 0, 0.12)",
          color: "#ff0000",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
      default:
        return {};
    }
  };

  const columns = [
    {
      name: "Sr. No.",
      width: "100px",
      selector: (row, index) => index + 1,
      sortable: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Name",
      minWidth: "220px",
      selector: (row) => row?.user_id?.full_name,
      sortable: true,
      cell: (row) => (
        <>{row?.user_id?.full_name ? row?.user_id?.full_name : "N/A"}</>
      ),
    },
    {
      name: "Start Date",
      minWidth: "190px",
      selector: (row) => row?.createdAt,
      sortable: true,
      cell: (row) => (row?.start_date ? formatDate(row?.start_date) : "N/A"),
    },
    {
      name: "End Date",
      minWidth: "190px",
      selector: (row) => row?.end_date,
      sortable: true,
      cell: (row) => (row?.end_date ? formatDate(row?.end_date) : "N/A"),
    },
    {
      name: "User Status",
      minWidth: "190px",
      selector: (row) => row?.user_id?.is_deleted,
      sortable: true,
      cell: (row) => (
        <>
          <span style={getStatusStyle2(row?.user_id?.is_deleted)}>
            {row?.user_id?.is_deleted == "0" ? "Active" : row?.user_id==null?"Deleted":"N/A"}
          </span>
        </>
      ),
    },
    {
      name: "Ad Status",
      minWidth: "190px",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <span style={getStatusStyle(row.status)}>
            {row.status == "approved"
              ? "Approved"
              : row.status == "rejected"
              ? "Rejected"
              : "Pending"}
          </span>
        </>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link
            className="btnview"
            to="/ads/view-ads"
            state={{ adsId: row._id }}
          >
            <Icon icon="tabler:eye" />
          </Link>

          <Link className="btndelete" onClick={() => handleShow(row._id)}>
            <Icon icon="tabler:trash" />
          </Link>

          {/* Show approve icon only if not already approved */}
          {row.status !== "approved" && (
            <Link
              className="btnview"
              onClick={() => handleapproveShow(row._id)}
            >
              <Icon icon="tabler:check" />
            </Link>
          )}

          {/* Show reject icon only if not already rejected */}
          {row.status !== "rejected" && (
            <Link
              className="btndelete"
              onClick={() => handlerejectShow(row._id)}
            >
              <Icon icon="tabler:x" />
            </Link>
          )}
        </>
      ),
    },
  ];
  const [data] = useState([
    {
      id: 1,
      name: "Laila",
      startDate: "2024-01-01",
      endDate: "2024-01-10",
      status: "Active",
    },
    {
      id: 2,
      name: "Mai My Oanh",
      startDate: "2024-02-01",
      endDate: "2024-02-15",
      status: "Inactive",
    },
    {
      id: 3,
      name: "Zaire Hassan",
      startDate: "2024-03-05",
      endDate: "2024-03-20",
      status: "Active",
    },
    {
      id: 4,
      name: "Kianna Rhiel Madsen",
      startDate: "2024-04-01",
      endDate: "2024-04-30",
      status: "Inactive",
    },
    {
      id: 5,
      name: "Rayna Lubin",
      startDate: "2024-05-10",
      endDate: "2024-05-25",
      status: "Active",
    },
    {
      id: 6,
      name: "Zaire Kenter",
      startDate: "2024-06-01",
      endDate: "2024-06-15",
      status: "Active",
    },
    {
      id: 7,
      name: "Jaxson Korsgaard",
      startDate: "2024-07-01",
      endDate: "2024-07-10",
      status: "Inactive",
    },
  ]);

  // Filter data based on search text
  const filteredData =
    adsData && adsData.length > 0
      ? adsData.filter(
          (item) =>
            JSON.stringify(item)
              .toLowerCase()
              .indexOf(searchText.toLowerCase()) !== -1
        )
      : [];
  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="d-flex align-items-center justify-content-between py-4">
              <h5>Ads</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              {loading ? (
                <Sentry
                  color="#2B5AAC"
                  size={30}
                  speed={1}
                  animating={true}
                  style={{ marginLeft: "45%" }}
                />
              ) : (
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  responsive
                  className="custom-table"
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            variant="outline-danger"
            onClick={handleClose}
            className="px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="px-4 min_width110"
            onClick={() => handleDelete(adsId)}
          >
            {deleteLoading ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              "Ok"
            )}
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        className="modal_Delete"
        show={showapprove}
        onHide={handleapproveClose}
        centered
      >
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="aprrovedicon" icon="iconoir:check-circle"></Icon>
            <h3>Are You Sure ?</h3>
            <p>you want to approve this ad?</p>
          </div>
          <Button
            variant="outline-danger"
            onClick={handleapproveClose}
            className="px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="px-4 min_width110"
            onClick={() => handleApprove(adsId)}
          >
            {loadingapprove ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              "Ok"
            )}
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        className="modal_Delete"
        show={showreject}
        onHide={handlerejectClose}
        centered
      >
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>you want to reject this ad?</p>
          </div>
          <Button
            variant="outline-danger"
            onClick={handlerejectClose}
            className="px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="px-4 min_width110"
            onClick={() => handleReject(adsId)}
          >
            {loadingreject ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              "Ok"
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
